<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-2">
          <h5 class="ma-0">Chaves de API</h5>
        </div>
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
        <template v-else>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            dense
            hide-details
            outlined
          />

          <v-data-table
            :loading="loading"
            :items="apiKeys"
            :headers="headers"
            :search="search"
            class="elevation-0"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="deleteApiKey(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:item.id="{ item }">
              {{ item.id.slice(0, 8) }}...
            </template>
            <template v-slot:item.expiresAt="{ item }">
              {{
                item.expiresAt
                  ? new Date(item.expiresAt).toLocaleDateString()
                  : "Não expira"
              }}
            </template>
            <template v-slot:item.active="{ item }">
              <v-chip small :color="item.active ? 'success' : 'error'" label>
                {{ item.active ? "Ativa" : "Inativa" }}
              </v-chip>
            </template>
          </v-data-table>
        </template>
      </div>
    </v-card>
    <admin-api-key @success="getApiKeys" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import API_KEYS from "@/services/admin/apiKeys";

import AdminApiKey from "@/components/admin/modals/AdminApiKey.vue";

export default {
  components: {
    AdminApiKey,
  },
  metaInfo: {
    title: "Chaves de API",
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "name" },
        { text: "Chave", value: "id" },
        { text: "Expira em", value: "expiresAt" },
        { text: "Ativa", value: "active" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      loading: false,
      apiKeys: [],
      search: "",
      permissions: null,
    };
  },
  methods: {
    ...mapActions("auth", ["getPermissions"]),
    newApiKey() {
      this.$root.$emit("api-key-modal");
    },
    decomposePermissions(permissions) {
      let result = [];
      Object.keys(this.permissions).forEach((p) => {
        if ((permissions & p) == p) result.push(p);
      });
      return result;
    },
    async getApiKeys() {
      try {
        this.loading = true;
        var response = await API_KEYS.getAll();
        this.apiKeys = response.apiKeys;
      } catch (error) {
        this.error = error.message || "Erro ao buscar chaves de API";
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteApiKey(item) {
      try {
        const confirm = window.confirm(
          "Tem certeza que deseja deletar a chave de API: " + item.name + "?"
        );
        if (!confirm) return;
        await API_KEYS.delete(item.id);
        this.getApiKeys();
      } catch (error) {
        console.error(error);
      }
    },
  },

  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    numberOfPages() {
      return Math.ceil(this.apiKeys.length / this.itemsPerPage);
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.apiKeys = [];
      this.getApiKeys();
    },
  },
  async mounted() {
    await this.getApiKeys();
  },
};
</script>
